import { ReactComponent as ValidDataCheck } from '../../../assets/colored/ic-colored-checkbox-checked.svg';
import { ReactComponent as InvalidDataCheck } from '../../../assets/colored/ic-colored-checkbox.svg';
import { Heading } from '../../tokens/Typography/Heading';

export interface PasswordValidationTexts {
  lengthRequirement: string;
  uppercaseRequirement: string;
  lowercaseRequirement: string;
  numberRequirement: string;
}

export interface PasswordValidationState {
  isLengthValid: boolean;
  isAtLeastOneCapital: boolean;
  isAtLeastOneLowerCase: boolean;
  isAtLeastOneNumber: boolean;
}

interface ValidationItemProps {
  isValid: boolean;
  text: string;
}

const ValidationItem = ({ isValid, text }: ValidationItemProps) => (
  <div className='flex items-center gap-[4px]'>
    {isValid ? <ValidDataCheck /> : <InvalidDataCheck />}
    <Heading.H10 className={`${isValid ? 'text-text-badge-green' : 'text-text-main-secondary'}`}>
      {text}
    </Heading.H10>
  </div>
);

interface PasswordStrengthIndicatorProps {
  validationState: PasswordValidationState;
  validationTexts: PasswordValidationTexts;
  containerClassName?: string;
}

export const PasswordStrengthIndicator = ({
  validationState,
  validationTexts,
  containerClassName,
}: PasswordStrengthIndicatorProps) => {
  return (
    <div className={`flex flex-col gap-[4px] ${containerClassName || ''}`}>
      <ValidationItem
        isValid={validationState.isLengthValid}
        text={validationTexts.lengthRequirement}
      />
      <ValidationItem
        isValid={validationState.isAtLeastOneCapital}
        text={validationTexts.uppercaseRequirement}
      />
      <ValidationItem
        isValid={validationState.isAtLeastOneLowerCase}
        text={validationTexts.lowercaseRequirement}
      />
      <ValidationItem
        isValid={validationState.isAtLeastOneNumber}
        text={validationTexts.numberRequirement}
      />
    </div>
  );
};
